import { render } from "./Expert.vue?vue&type=template&id=09644365&scoped=true"
import script from "./Expert.vue?vue&type=script&lang=js"
export * from "./Expert.vue?vue&type=script&lang=js"

import "./Expert.vue?vue&type=style&index=0&id=09644365&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09644365"]])

export default __exports__